import CttContentComponent from './CttContentComponent'

export default CttContentComponent
